<footer class="footer">
	<div class="footer-bottom">
		<span>
			{{ footerConstants.copyright }}
		</span>
		<div class="footer-links">
			<a href="https://www.arrowxl.co.uk/terms-conditions" target="_blank">{{ footerConstants.termAndCondition }}</a> |
			<a href="https://www.arrowxl.co.uk/privacy-policy" target="_blank">{{ footerConstants.privacyPolicy }}</a> |
			<a href="https://www.arrowxl.co.uk/accessibility" target="_blank">{{ footerConstants.accessibility }}</a>
		</div>
	</div>
</footer>
